<template>
  <detail-layout-two-columns :toEdge="false">
    <template slot="LeftCol">
      <base-header style="padding-left: 0px" icon="user" :content="header" />
      <div class="form-wrapper">
        <el-form :model="form" ref="ruleForm">
          <div class="hideHScroll">
            <div class="lg:mb-4" v-if="role === 3">
              <base-ro-input :label="$t('clients.entity_name')" :data="form.Empresa" />
            </div>
              <div class="lg:mb-4 flex -mx-2 flex-col lg:flex-row">
                <div class="px-2 w-full mb-2 lg:mb-0">
                  <base-ro-input :label="$t('invoices.num_factura')" :data="form.numFactura"/>
                </div>
                <div class="px-2 w-full mb-2 lg:mb-0" v-if="form.SerieFactura && form.SerieFactura.trim() !== ''">
                  <base-ro-input :label="$t('invoices.serie_factura')" :data="form.SerieFactura" />
                </div>
              </div>

            <div class="lg:mb-4 flex -mx-2 flex-col lg:flex-row">
              <div class="px-2 w-full mb-2 lg:mb-0">
                <base-ro-input :label="$t('invoices.emisor')" :data="form.NombreCIFEmisor" />
              </div>
              <div class="px-2 w-full mb-2 lg:mb-0">
                <base-ro-input :label="$t('invoices.cif_emisor')" :data="form.cifEmisor" />
              </div>
            </div>
            <div class="lg:mb-4 flex -mx-2 flex-col lg:flex-row">
              <div class="px-2 w-full mb-2 lg:mb-0">
                <base-ro-input :label="$t('invoices.receptor')" :data="form.NombreCIFReceptor" />
              </div>
              <div class="px-2 w-full mb-2 lg:mb-0">
                <base-ro-input :label="$t('invoices.cif_receptor')" :data="form.cifReceptor" />
              </div>
            </div>
            <div class="lg:mb-4 flex -mx-2 flex-col lg:flex-row">
              <div class="px-2 w-full mb-2 lg:mb-0">
                <base-ro-input :label="$t('invoices.fecha_emision')" :data="form.fechaFactura" />
              </div>
              <div class="px-2 w-full mb-2 lg:mb-0">
                <base-ro-input :label="$t('invoices.total_invoice')" :data="form.importe + ''" />
              </div>
            </div>
            <div class="lg:mb-4 flex -mx-2 flex-col lg:flex-row">
              <!-- <div class="px-2 w-full mb-2 lg:mb-0">
                    <base-ro-input :label="$t('app.status')" :data="form.Estado"/>
                  </div> -->
              <!-- <div class="px-2 w-full mb-2 lg:mb-0">
                    <base-ro-input :label="$t('invoices.tipo_factura')" :data="form.tipoInvoiceClass"/>
                  </div> -->
              <div class="px-2 w-full mb-2 lg:mb-0">
                <base-ro-input :label="form.EsRecibida ? $t('app.forma_recepcion') : $t('app.forma_envio')" :data="form.pgeTypeName" />
              </div>
              <div v-if="form.FechaAlta" class="px-2 w-full mb-2 lg:mb-0">
                <base-ro-input :label="$t('invoices.fecha_alta')" :data="form.FechaAlta" />
              </div>
            </div>
            <!-- <div class="lg:mb-4 flex -mx-2 flex-col lg:flex-row">
                  <div class="px-2 w-full mb-2 lg:mb-0">
                    <base-ro-input :label="$t('invoices.tipo_factura')" :data="form.tipoFactura"/>
                  </div>
                  <div class="px-2 w-full mb-2 lg:mb-0">
                    <base-ro-input :label="$t('invoices.concepto')" :data="form.concepto"/>
                  </div>
              </div>    -->

            <div v-if="form.csv" class="lg:mb-4">
              <base-ro-input :label="$t('invoices.csv')" :data="form.csv" />
            </div>

            <div class="lg:mb-4 flex -mx-2 flex-col lg:flex-row">
              <div v-if="form.NumAsiento" class="px-2 w-full mb-2 lg:mb-0">
                <base-ro-input :label="$t('invoices.seat_number')" :data="form.NumAsiento" />
              </div>
              <div v-if="form.FechaEntradaERP" class="px-2 w-full mb-2 lg:mb-0">
                <base-ro-input :label="$t('invoices.erp_entry_date')" :data="form.FechaEntradaERP" />
              </div>
            </div>

            <div class="lg:mb-4 flex -mx-2 flex-col lg:flex-row">
              <div v-if="form.FechaPago" class="px-2 w-full mb-2 lg:mb-0">
                <base-ro-input :label="$t('invoices.fecha_pago')" :data="form.FechaPago" />
              </div>
              <div v-if="form.FechaRechazo" class="px-2 w-full mb-2 lg:mb-0">
                <base-ro-input :label="$t('invoices.fecha_rechazo')" :data="form.FechaRechazo" />
              </div>
            </div>

            <div class="mt-8 lg:mb-4">
              <h3 class="dark:text-darkblue-200 font-bold mt-4 mb-2">{{ $t('invoices.importes') }}</h3>
              <el-table ref="importes" :data="form.importes" style="width: 100%" :empty-text="$t('app.no_data_text')"
                :show-header="form.importes && form.importes.length > 0">
                <el-table-column prop="Base" :label="$t('invoices.taxable_base')" min-width="120" show-overflow-tooltip>
                </el-table-column>
                <el-table-column prop="Tipo" :label="$t('invoices.tax_rate')" min-width="120" show-overflow-tooltip>
                </el-table-column>
                <el-table-column prop="Importe" :label="$t('invoices.tax_amount')" min-width="120" show-overflow-tooltip>
                </el-table-column>
              </el-table>
            </div>
            <div v-if="hasTBAIModule && !form.EsRecibida && hasTBAIInformation" class="mt-8 lg:mb-4">
              <h3 class="dark:text-darkblue-200 font-bold mt-4 md:mb-2 lg:mb-5">{{$t('invoices.informacion_ticketbai')}}</h3>
              <div class="lg:mb-4 flex -mx-2 flex-col lg:flex-row">
                <div class="px-2 w-full mb-2 lg:mb-0" v-if="form.estadoTicketbai">
                  <base-ro-input :label="$t('invoices.estado_ticketbai')" :data="form.estadoTicketbai" />
                </div>
                <div v-if="form.fechaTicketbaiRegistro" class="px-2 w-full mb-2 lg:mb-0">
                  <base-ro-input :label="$t('invoices.fecha_registro_ticketbai')" :data="form.fechaTicketbaiRegistro" />
                </div>
              </div>
              <div class="lg:mb-4" v-if="form.IdTBAI">
                <base-ro-input :label="$t('invoices.id_ticketbai')"
                  :data="form.IdTBAI" />
              </div> 
              <div class="lg:mb-4" v-if="form.CSVEnvioTBAI">
                <base-ro-input :label="$t('invoices.csv_ticketbai')"
                  :data="form.CSVEnvioTBAI" />
              </div> 
              <div class="lg:mb-4 flex -mx-2 flex-col lg:flex-row">
                <div class="px-2 w-full mb-2 lg:mb-0" v-if="form.Hacienda">
                  <div class="flex-col">
                    <label class="text-sm font-semibold text-secondary-600 dark:text-darkblue-400 black:text-darkblue-500 block mb-1">{{ form.fechaTicketbaiEnvio? $t('companies.enviada_hacienda'):$t('companies.pendiente_hacienda') }}</label>
                    <span class="min-input-height flex items-center border-b border-solid border-gray-100 dark:text-darkblue-200 black:text-darkblue-500 dark:border-darkblue-600 whitespace-pre-wrap">{{ form.Hacienda }}</span>
                    <base-button class="mt-1" @click.prevent="openUrlHacienda" :text="$t('invoices.consultar_hacienda')"></base-button>
                  </div>
                </div>
                <div v-if="form.fechaTicketbaiEnvio" class="px-2 w-full mb-2 lg:mb-0">
                  <base-ro-input :label="$t('invoices.fecha_entrega_ticketbai')" :data="form.fechaTicketbaiEnvio" />
                </div>
              </div>
              <div v-if="form.ResultadosValidacion" class="mt-8 lg:mb-4">
                <h3 class="dark:text-darkblue-200 font-bold mt-4 mb-2">{{ $t('invoices.tbai_validation') }}</h3>
                <el-table  ref="importes" :data="form.ResultadosValidacion" style="width: 100%" height="250"
                  :show-header="form.ResultadosValidacion && form.ResultadosValidacion.length > 0">
                  <el-table-column prop="Codigo" label="Codigo" show-overflow-tooltip align="center">
                  </el-table-column>
                  <el-table-column prop="Descripcion" label="Descripcion" min-width="400" show-overflow-tooltip>
                  </el-table-column>
                </el-table>
              </div>
            </div>
            <div v-if="hasVerifactuModule && !form.EsRecibida && hasVerifactuInformation" class="mt-8 lg:mb-4">
              <h3 class="dark:text-darkblue-200 font-bold mt-4 md:mb-2 lg:mb-5">{{$t('invoices.informacion_verifactu')}}</h3>
              <div class="lg:mb-4 flex -mx-2 flex-col lg:flex-row">
                <div class="px-2 w-full mb-2 lg:mb-0">
                  <base-ro-input :label="$t('invoices.qr_verifactu')" :data="form.urlVerifactu" />
                </div>
              </div>
              <div class="lg:mb-4" v-if="form.CSVVerifactu">
                <base-ro-input :label="$t('invoices.csv_verifactu')"
                  :data="form.CSVVerifactu" />
              </div> 
              <div class="lg:mb-4 flex -mx-2 flex-col lg:flex-row">
                <div class="px-2 w-full mb-2 lg:mb-0">
                  <div class="flex-col">
                    <base-button class="mt-1" @click.prevent="openUrlVerifactu" :text="$t('invoices.consultar_aeat')"></base-button>
                  </div>
                </div>
              </div>
            </div>
            <div class="mt-8 lg:mb-4">
              <h3 class="dark:text-darkblue-200 font-bold mt-4 mb-2">{{ $t('invoices.invoices_documents') }}</h3>
              <el-table ref="documentos" :data="form.Adjuntos" style="width: 100%" :empty-text="$t('app.no_data_text')"
                :show-header="form.Adjuntos && form.Adjuntos.length > 0">
                <el-table-column prop="tipo" width="36" align="center">
                  <template slot-scope="tipos">
                    <el-tooltip v-if="tipos.row.tipo" placement="left">
                      <div slot="content">
                        <div class="max-w-sm max-h-500p overflow-auto">
                          <div v-if="tipos.row.tipo === 'xml'">{{ $t('invoices.xml_invoice') }}</div>
                          <div v-else>{{ $t('invoices.document_adj_emb_long') }}</div>
                        </div>
                      </div>
                      <base-icon :name="tipos.row.tipo" />
                    </el-tooltip>
                  </template>
                </el-table-column>
                <el-table-column prop="Nombre" :label="$tc('app.documents', 1)" min-width="230" show-overflow-tooltip>
                </el-table-column>
                <el-table-column prop="actions" width="180" align="center" :label="$tc('app.actions', 2)">
                  <template slot-scope="adjuntos">
                    <div class="flex flex-row">
                      <base-button-icon v-if="adjuntos.row.icon === 'eye' || adjuntos.row.icon === 'eyeslash'"
                        class="mr-2" @click="showAdjunto(adjuntos.row, true)" :name="adjuntos.row.icon" mode="core" />
                      <base-button-icon @click="downloadAdjunto(adjuntos.row, false)" name="download" mode="core" />
                      <base-button-icon @click="printAdjunto(adjuntos.row, false)" name="printer" mode="core" />
                    </div>
                  </template>
                </el-table-column>
                <el-table-column prop="Extension" :label="$t('app.extension')" width="90">
                </el-table-column>
              </el-table>
            </div>
            <div class="mt-8">
              <h3 class="dark:text-darkblue-200 font-bold mt-4 mb-2">{{ $t('invoices.documents_rel') }}</h3>
              <el-table ref="documentos" :data="form.DocumentosRelacionados" style="width: 100%" :empty-text="$t('app.no_data_text')"
                :show-header="form.DocumentosRelacionados && form.DocumentosRelacionados.length > 0">
                <el-table-column prop="Nombre" :label="$tc('app.documents', 1)" min-width="266" show-overflow-tooltip>
                </el-table-column>
                <el-table-column prop="actions" width="180" align="center" :label="$tc('app.actions', 2)">
                  <template slot-scope="relacionados">
                    <div class="flex flex-row">
                      <base-button-icon v-if="relacionados.row.icon === 'eye' || relacionados.row.icon === 'eyeslash'"
                        class="mr-2" @click="showDocRel(relacionados.row, true)" :name="relacionados.row.icon"
                        mode="core" />
                      <base-button-icon @click="downloadAdjunto(relacionados.row, true)" name="download" mode="core" />
                    </div>
                  </template>
                </el-table-column>
                <el-table-column prop="Extension" :label="$t('app.extension')" width="90">
                </el-table-column>
              </el-table>
            </div>
            <metadatos-table-view v-if="form.idEstado !== 12" :showActions="false"
              :idCliente="form.idCliente" :idFacturae="idFacturae" :idInvoice="idInvoice" :metadatos="form.Metadatos" />
            <div class="pb-10">
              <label
                class="dark:text-darkblue-200 text-sm font-semibold text-secondary-600 block mb-1">{{ $t('invoices.notas') }}</label>
              <el-form-item prop="full_text">
                <el-input :disabled="true" type="textarea" :rows="3" clearable class="w-full" v-model="form.full_text"
                  maxlength="1000" />
              </el-form-item>
            </div>
          </div>
        </el-form>
      </div>
    </template>
    <template slot="RightCol">
      <div :class="{ 'h-screen': showPdf }"
        class="bg-primary-50 dark:bg-darkblue-800 dark:text-darkblue-200 xl:inline-block relative w-full flex-grow hideHScroll lg:h-full divide-y-2 divide-blue-200 dark:divide-gray-800">
        <img v-if="!showXhtml && !showPdf && showImage" :src="srcImage" :alt="imageFilename" class="m-auto">
        <PDFViewerApp
          v-show="!showXhtml && showPdf && !showImage"
          :search="actualFilterContent"
          @pdfViewerOpenHandler="pdfViewerOpenHandler"
          :pdf="url"/>
        <iframe v-if="showXhtml" id="container-xhtml-iframe" class="w-full p-2 iframe-xhtml" scrolling="auto" ref="frame">
        </iframe>
      </div>
      <!-- <base-dropdown-floating-button v-if="showXhtml" mode="primary" :secondaryButtons="facturaeActions" hover /> -->
      <base-button-icon v-if="showXhtml" name="printer" mode="primary" iconSize="lg" size="xl" @click="printXMLView"
        style="position: absolute; right: 2%; bottom: 10%;" />
    </template>
    <template slot="layout-extend">
      <base-footer>
        <template slot="actions">
          <base-button-responsive mode="secondary" :text="$t('app.back')" icon="cross" @click="goBack"
            :loading="isGeneralLoading" type="button" />
          <base-button-responsive v-if="showInvoiceActions" mode="primary" :text="$t('trash.delete')" icon="check" @click="deleteFactura()"
            :loading="isGeneralLoading" :disabled="isGeneralLoading" type="button" />
          <base-button-responsive v-if="showInvoiceActions" mode="primary" :text="$t('trash.restore')" icon="check" @click="restoreFactura()"
            :loading="isGeneralLoading" :disabled="isGeneralLoading" type="button" />
        </template>
      </base-footer>
      <Dialog :title="$t('invoices.delete_invoice')" :visible.sync="showModal" width="40%" custom-class="min-width-dialog" center>
        <span class="text-center w-full inline-block dark:text-darkblue-200 word-break-n">{{ processMessage }}</span>
        <template slot="footer">
          <div class="flex flex-col lg:flex-row w-full lg:w-auto items-center space-y-2 lg:space-y-0 lg:space-x-2">
            <base-button class="w-full" @click="showModal = false" mode="secondary-phantom-blue" :text="$t('app.cancel')" />
            <base-button class="w-full" mode="secondary-phantom-blue" :text="$t('app.apply')"
              @click="() => { deleteHandler(); showModal = false }" />
          </div>
        </template>
      </Dialog>
    </template>
  </detail-layout-two-columns>
</template>

<script>
import { i18n } from '@/i18n'

import DetailLayoutTwoColumns from '@/components/layout/DetailLayoutTwoColumns.vue'
import PDFViewerApp from '@/components/pdf/PDFViewerApp.vue'
import MetadatosTableView from '@/components/MetadatosTableView.vue'
import { Dialog } from 'element-ui'

import { getXHTMLFactura } from '@/services/invoices/getXHTMLFactura'
import { getInvoice } from '@/services/invoices/getInvoice'
import { descargarAdjunto } from '@/services/invoices/descargarAdjunto'
import { descargarDocRel } from '@/services/invoices/descargarDocRel'
import { deleteTrashInvoice } from '@/services/trash/deleteTrashInvoice'
import { restoreTrashInvoice } from '@/services/trash/restoreTrashInvoice'
import { descargarDocFactura } from '@/services/invoices/descargarDocFactura'

export default {
  name: 'detalle-papelera-notificacion',
  components: {
    DetailLayoutTwoColumns,
    MetadatosTableView,
    PDFViewerApp,
    Dialog
  },
  data: function () {
    return {
      dateRangeOptions: {
        firstDayOfWeek: 1,
      },
      showNewDocument: false,
      showNewMetadato: false,
      showPdf: false,
      showXhtml: false,
      showImage: false,
      srcImage: '',
      imageFilename: '',
      activeName: 'es',
      header: {
        title: i18n.t('trash.invoice_detail'),
        icon: 'docblack',
        breadcrumb: {},
        nav: [],
        url: ''
      },
      reg: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/,
      form: {
        Adjuntos: [],
        DocumentosRelacionados: [],
        Empresa: '',
        numFactura: '',
        SerieFactura: '',
        fechaFactura: '',
        idCliente: 0,
        cifReceptor: '',
        NombreCIFReceptor: '',
        cifEmisor: '',
        NombreCIFEmisor: '',
        importe: null,
        tipoFactura: null,
        full_text: '',
        enlaceDescarga: '',
        Estado: '',
        tipoInvoiceClass: '',
        importes: [],
        contentHhtmlXslt: '',
        csv: '',
        NumAsiento: '',
        FechaEntradaERP: '',
        FechaPago: '',
        FechaRechazo: '',
        FechaAlta: '',
        UltimoError: '',
        pgeType: '',
        pgeTypeName: '',
        EsRecibida: false,
        Metadatos: [],
        fechaTicketbaiRegistro: '',
        fechaTicketbaiEnvio: '',
        IdTBAI: null,
        estadoTicketbai: null,
        Hacienda: '',
        urlHacienda: '',
        CSVEnvioTBAI: '',
        ResultadosValidacion: [],
        urlVerifactu: '',
        CSVVerifactu: '',
      },
      url: '',
      documentError: undefined,
      enableUploader: false,
      idLastAdjuntoVisible: 0,
      showModal: false,
      processMessage: i18n.t('app.delete_permanent_current_confirmation_f', { entity: i18n.t('invoices.entity_name').toLowerCase() }),
      selectedAction: null,
      actualFilterContent: null,
      facturaeActions: [{
        name: 'download',
        listener: () => this.downloadXMLView(),
        loading: false,
      },
      {
        name: 'printer',
        listener: () => this.printXMLView(),
        loading: false,
      }],
    }
  },
  watch: {
    showXhtml: function (value, oldValue) {
      if (value) {
        setTimeout(() => {
          this.insertIframeContent()
        }, 200)
      }
    },
  },
  computed: {
    routeBack: function () {
      const invoiceType = this.form.EsRecibida ? 'received' : 'issued'
      return `trash/invoices${invoiceType}`
    },
    headerTitle: function () {
      return this.form.EsRecibida ? i18n.t('trash.invoice_received_detail') : i18n.t('trash.invoice_issued_detail')
    },
    pgeTypes: function () {
      return this.form.EsRecibida ? this.$store.getters['config/TIPOS_PGE_RECEPCION'] : this.$store.getters['config/TIPOS_PGE']
    },
    tiposEstado: function () {
      if (this.form.EsRecibida) {
        return this.$store.getters['config/TIPOS_ESTADO_RECEPCION']
      }
      return this.$store.getters['config/TIPOS_ESTADO']
    },
    tiposAccion: function () {
      return this.$store.getters['config/TIPOS_ACCION']
    },
    tiposHacienda: function () {
      return this.$store.getters['config/TIPOS_HACIENDA']
    },
    tiposEstadoTBAI: function () {
      return this.$store.getters['config/TIPOS_ESTADOS_TBAI']
    },
    isGeneralLoading: function () {
      return this.$store.getters.isLoading
    },
    role: function () {
      return this.$store.getters['auth/role']
    },
    hasTBAIModule () {
      return !!this.$store.getters['auth/hasTBAIModule']
    },
    hasVerifactuModule () {
      return !!this.$store.getters['auth/hasVerifactuModule']
    },
    showInvoiceActions: function () {
      return this.role !== 4 && this.hasAllPropietariosByGroups
    },
    isCollapsed: function () {
      return (this.collapse ? 'expand' : 'collap')
    },
    idInvoice: function () {
      return parseInt(this.$route.params.idInvoice)
    },
    idFacturae: function () {
      return parseInt(this.$route.params.idFacturae)
    },
    canUseCopyClipboard: function () {
      return this.form.enlaceDescarga !== null && this.form.enlaceDescarga !== undefined && this.form.enlaceDescarga !== ''
    },
    userGroups: function () {
      return this.$store.getters['auth/user']?.Grupos
    },
    hasAllPropietariosByGroups () {
      return this.role === 3 || this.userGroups.some(y => y.idGrupo === this.form.idGrupoPropietario || y.idTipo === 1)
    },
    hasTBAIInformation () {
      return this.form.idTicketBai || this.form.fechaTicketbai || this.form.estadoTicketbai
    },
    hasVerifactuInformation () {
      return !!this.form.urlVerifactu
    },
  },
  created: async function () {
    this.filterByParamsData()

    await this.downloadInvoiceData()

    this.header.url = this.routeBack

    const breadcrumbs = []
    var invoiceType = this.form.EsRecibida ? 'received' : 'issued'
    breadcrumbs.push({ path: `trash/invoices${invoiceType}`, name: i18n.t('trash.header') })
    breadcrumbs.push({ path: `trash/invoices${invoiceType}`, name: this.form.EsRecibida ? i18n.t('trash.invoices_received_short') : i18n.t('trash.invoices_issued_short') })
    const asuntoBreadCrumb = this.form.numFactura
    breadcrumbs.push({ path: '', name: this.truncate(asuntoBreadCrumb, 30, false) })
    this.$store.commit('app/setheaderBreadCrumb', asuntoBreadCrumb)
    this.header.breadcrumb = breadcrumbs
    this.header.title = this.headerTitle

    if (this.form.Adjuntos !== undefined && this.form.Adjuntos.length > 0) {
      this.showAdjunto(this.form.Adjuntos[0], true)
    }
  },
  methods: {
    pdfViewerOpenHandler () {
      this.actualFilterContent = null
    },
    filterByParamsData () {
      const data = this.$route.params.data
      if (data) {
        data.filters.forEach(filter => {
          if (filter.type === 'contenido') {
            this.actualFilterContent = filter.data
          } 
        })
      }
    },
    goBack: function () {
      var invoiceType = this.form.EsRecibida ? 'received' : 'issued'
      this.$router.push({ name: `trash/invoices${invoiceType}` })
    },
    deleteFactura () {
      this.showModal = !this.showModal
    },
    deleteHandler: async function () {
      try {
        this.$store.commit('setIsLoading', true)
        const payload = {
          idsFacturas: []
        }
        payload.idsFacturas.push({
          idFacturae: this.idFacturae,
          idInvoice: this.idInvoice,
        })
        const response = await deleteTrashInvoice(payload)
        if (response.blnError === true) {
          this.doFeedback(`${response.msgError} [${response.codError}]`)
        } else {
          this.doFeedback(i18n.t('feedback.success.action_tramited_msg'), 'success')
        }
      } catch (error) {
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
        this.goBack()
      }
    },
    restoreFactura: async function () {
      try {
        this.$store.commit('setIsLoading', true)
        const payload = {
          idsFacturas: []
        }
        payload.idsFacturas.push({
          idFacturae: this.idFacturae,
          idInvoice: this.idInvoice,
        })
        const response = await restoreTrashInvoice(payload)
        if (response.blnError === true) {
          this.doFeedback(`${response.msgError} [${response.codError}]`)
        } else {
          this.doFeedback(i18n.t('feedback.success.action_tramited_msg'), 'success')
        }
      } catch (error) {
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
        this.goBack()
      }
    },
    toggleSearchView: function () {
      this.searchView = !this.searchView
    },
    downloadInvoiceData: async function () {
      try {
        this.$store.commit('app/setLoading', true)
        const params = {
          idInvoice: this.idInvoice,
          idFacturae: this.idFacturae,
        }
        await this.downloadInvoiceDataMetadata(params)
        if (this.form.FacturaeFile.Extension.toLocaleLowerCase() === 'xml') {
          this.downloadInvoiceDataXHTML(params)
        } else {
          // this.showAdjunto(this.form.Adjuntos[0], true)
        }
      } catch (error) {
        this.doFeedback(i18n.t('feedback.error.general'))
      } finally {
        this.$store.commit('app/setLoading', false)
      }
    },
    downloadInvoiceDataMetadata: async function (params) {
      try {
        const invoice = await getInvoice(params)
        if (invoice.blnError) {
          this.doFeedback(`${invoice.msgError} [${invoice.codError}]`)
        }
        this.setInvoice(invoice.respuesta)
      } catch (error) {
        this.doFeedback(i18n.t('feedback.error.general'))
      }
    },
    downloadInvoiceDataXHTML: async function (params) {
      try {
        const htmlxslt = await getXHTMLFactura(params)
        if (htmlxslt.blnError === true) {
          this.doFeedback(`${htmlxslt.msgError} [${htmlxslt.codError}]`)
        } else {
          this.form.contentHhtmlXslt = htmlxslt.Respuesta
          this.showXhtml = true
          this.insertIframeContent()
        }
        // this.mountScript(htmlxslt.Respuesta)
      } catch (error) {
        this.doFeedback(i18n.t('feedback.error.general'))
      }
    },
    insertIframeContent () {
      let iframe = document.getElementById('container-xhtml-iframe')

      iframe = iframe.contentWindow || (iframe.contentDocument.document || iframe.contentDocument)

      iframe.document.open()
      iframe.document.write(this.form.contentHhtmlXslt)
      iframe.document.close()
    },
    mountScript (xhtml) {
      // Eliminamos script si existe
      const id = 'scriptxhtmlcustom'
      try {
        this.removeElement(id)
      } catch (error) {
      }

      // Extraemos nuevo script del xhtml
      const result = xhtml.match(/(?<=<script>\s*).*?(?=\s*<\/script>)/gs) // Returns multiple matches if any
      const scriptXhtml = document.createElement('script')
      scriptXhtml.id = id
      scriptXhtml.innerHTML = result[0]

      // Insertamos script
      document.head.appendChild(scriptXhtml)
    },
    removeElement (id) {
      const elem = document.getElementById(id)
      elem.parentNode.removeChild(elem)
    },
    setInvoice: function (invoice) {
      this.form.EsRecibida = invoice.EsRecibida
      this.form.fechaFactura = i18n.d(invoice.FechaFactura, 'numeric_date', { date: '-' })
      this.form.Estado = invoice.Estado
      this.form.tipoInvoiceClass = invoice.TipoInvoiceClass
      this.form.numFactura = invoice.NumFactura
      this.form.SerieFactura = invoice.SerieFactura
      this.form.Empresa = invoice.NombreCliente
      this.form.NombreCIFReceptor = invoice.NombreCIFReceptor
      this.form.cifReceptor = invoice.CIFReceptor
      this.form.NombreCIFEmisor = invoice.NombreCIFEmisor
      this.form.cifEmisor = invoice.CIFEmisor
      this.form.importe = i18n.n(invoice.Importe, 'currency')
      this.form.idCliente = invoice.idCliente
      this.form.full_text = invoice.Notas
      this.form.tipoFactura = invoice.Tipo
      this.form.enlaceDescarga = invoice.EnlaceDescarga
      this.form.importes = invoice.Importes || []
      this.form.importes.forEach(x => {
        x.Base = i18n.n(x.Base, 'currency')
        x.Importe = i18n.n(x.Importe, 'currency')
        // x.Tipo = i18n.n(x.Tipo/100, 'percent') // Descomentar si se quiere incluir el símbolo '%'
      })
      this.form.csv = invoice.Csv
      this.form.NumAsiento = invoice.NumAsiento
      this.form.FechaEntradaERP = invoice.FechaEntradaERP ? i18n.d(invoice.FechaEntradaERP, 'numeric_date', { date: '-' }) : null
      this.form.FechaAlta = invoice.FechaAlta ? i18n.d(invoice.FechaAlta, 'numeric_date', { date: '-' }) : null
      this.form.FechaPago = invoice.FechaPago ? i18n.d(invoice.FechaPago, 'numeric_date', { date: '-' }) : null
      this.form.FechaRechazo = invoice.FechaRechazo ? i18n.d(invoice.FechaRechazo, 'numeric_date', { date: '-' }) : null
      this.form.UltimoError = invoice.UltimoError
      this.form.pgeType = invoice.Pge
      this.form.pgeTypeName = this.pgeTypes.filter(x => x.id === invoice.Pge)[0].name
      this.form.idGrupoPropietario = invoice.GrupoPropietario.idGrupo
      this.form.fechaTicketbaiRegistro = invoice.ResultadosEnvioTBAI?.HoraRegistro ? i18n.d(invoice.ResultadosEnvioTBAI?.HoraRegistro, 'numeric_datetime', { date: '-', datetime: ' ' }) : null
      this.form.fechaTicketbaiEnvio = invoice.ResultadosEnvioTBAI?.HoraEnvio ? i18n.d(invoice.ResultadosEnvioTBAI?.HoraEnvio, 'numeric_datetime', { date: '-', datetime: ' ' }) : null
      this.form.IdTBAI = invoice.IdTBAI
      this.form.estadoTicketbai = this.tiposEstadoTBAI.filter(x => parseInt(x.value) === invoice.ResultadosEnvioTBAI?.idEstadoTBAI)[0]?.label ?? invoice.ResultadosEnvioTBAI?.idEstado
      this.form.Hacienda = this.tiposHacienda.filter(x => parseInt(x.value) === invoice.ResultadosEnvioTBAI?.Hacienda)[0]?.label ?? invoice.ResultadosEnvioTBAI?.Hacienda
      this.form.urlHacienda = invoice.ResultadosEnvioTBAI?.URLTBAI
      this.form.CSVEnvioTBAI = invoice.ResultadosEnvioTBAI?.CSVEnvioTBAI
      this.form.ResultadosValidacion = invoice.ResultadosEnvioTBAI?.ResultadosValidacion
      this.form.urlVerifactu = invoice.URLVerifactu
      this.form.CSVVerifactu = invoice.CSVVerifactu

      this.form.FacturaeFile = invoice.FacturaeFile || {
        idRelatedDocument: 0,
        Nombre: 'Fichero XML',
        Extension: 'xml',
        Relacionado: false
      }
      this.form.Adjuntos = invoice.Adjuntos
      this.form.Adjuntos.forEach(x => this.$set(x, 'icon', 'eye')&this.$set(x, 'visible', false))
      // Añadimos fichero xml 
      this.form.Adjuntos.unshift({
        Extension: this.form.FacturaeFile.Extension,
        Nombre: this.form.FacturaeFile.Nombre,
        idRelatedDocument: this.form.FacturaeFile.idRelatedDocument,
        icon: 'eyeslash',
        visible: false,
        Relacionado: this.form.FacturaeFile.Relacionado
      })
      this.form.DocumentosRelacionados = invoice.FicherosRelacionados
      this.form.DocumentosRelacionados.forEach(x => this.$set(x, 'icon', 'eye')&this.$set(x, 'visible', false))

      if (invoice.MetadatosAdicionales !== undefined) {
        this.form.Metadatos = invoice.MetadatosAdicionales
          .filter((x) => x.Valor !== '' && x.Campo !== 'XmlNotificacion')
          .sort((a, b) => {
            if (a.Campo < b.Campo) return -1
            if (a.Campo > b.Campo) return 1
            return 0
          })
      }
      this.resetDocumentsSelected()
    },
    resetDocumentsSelected: async function (rowException = null) {
      if (this.form.DocumentosRelacionados) {
        this.form.DocumentosRelacionados.forEach(key => {
          if (!rowException || !(rowException.docRel && rowException.idRelatedDocument === key.idRelatedDocument)) {
            key.visible = false
            key.icon = key.Extension.trim().toUpperCase() === 'PDF' || key.Extension.trim().toUpperCase() === 'PNG' ? 'eye' : 'download'
          }
        })
      }
      this.form.Adjuntos.forEach(key => {
        if (!rowException || !(!rowException.docRel && rowException.idRelatedDocument === key.idRelatedDocument)) {
          key.visible = false
          if (key.idRelatedDocument === 0 && key.Extension.trim().toUpperCase() === 'XML') {
            key.icon = 'eye'
            key.tipo = 'xml'
          } else {
            key.icon = key.Extension.trim().toUpperCase() === 'PDF' || key.Extension.trim().toUpperCase() === 'PNG' ? 'eye' : 'download'
            key.tipo = key.Relacionado ? 'xmlembed' : null
          }
        }
      })
    },
    showAdjunto: async function (row, withoutEvent) {
      const docRel = false
      const exceptionDocument = {
        docRel,
        idRelatedDocument: row.idRelatedDocument,
      }
      this.resetDocumentsSelected(exceptionDocument)
      // Documento facturae (documento xml de la factura)
      if (row.idRelatedDocument === 0 && row.Extension.trim().toUpperCase() === 'XML') {
        this.showPdf = false
        this.showImage = false
        if (row.icon === 'eye') {
          this.showXhtml = true
          row.visible = true
          row.icon = 'eyeslash'
        } else {
          this.showXhtml = false
          row.icon = 'eye'
        }
      } else {
        if (row.Extension.trim().toUpperCase() === 'PDF') {
          this.showXhtml = false
          this.showImage = false
          await this.showPDFHandler(row.idRelatedDocument, withoutEvent, docRel)
          if (row.icon === 'eye') {
            row.icon = 'eyeslash'
            row.visible = true
            this.showPdf = true
          } else {
            console.log(row)
            row.icon = 'eye'
            this.showPdf = false
          }
        } else {
          await this.downloadAdjunto(row, docRel)
        }
      }
    },
    showDocRel: async function (row, withoutEvent) {
      const docRel = true
      const exceptionDocument = {
        docRel,
        idRelatedDocument: row.idRelatedDocument,
      }
      await this.resetDocumentsSelected(exceptionDocument)
      if (row.Extension.trim().toUpperCase() === 'PDF') {
        this.showXhtml = false
        this.showImage = false
        await this.showPDFHandler(row, withoutEvent, docRel)
        if (row.icon === 'eye') {
          row.icon = 'eyeslash'
          this.showPdf = true
        } else {
          row.icon = 'eye'
          this.showPdf = false
        }
        this.resetRowName(row)
      } else if (row.Extension.trim().toUpperCase() === 'PNG') {
        this.showXhtml = false
        this.showPdf = false
        await this.showImageVisor(row)
        if (row.icon === 'eye') {
          row.icon = 'eyeslash'
          this.showImage = true
        } else {
          row.icon = 'eye'
          this.showImage = false
        }
        this.resetRowName(row)
      } else {
        await this.downloadAdjunto(row, docRel)
      }
    },
    showImageVisor: async function (row) {
      this.$store.commit('app/setLoading', true)
      const params = {
        idFacturae: this.idFacturae,
        idInvoice: this.idInvoice,
        idRelatedDocument: row.idRelatedDocument,
      }
      const response = await descargarDocRel(params)
      const blob = new Blob([response.data], { type: response.data.type, encoding: 'UTF-8' })
      this.showPdf = false
      this.showXhtml = false
      this.showImage = true
      this.srcImage = window.URL.createObjectURL(blob)
      this.imageFilename = decodeURI(row.Nombre)
    },
    onDocumentErrored: function (e) {
      this.documentError = e.text
    },
    downloadAdjunto: async function (row, docRel = false) {
      try {
        this.$store.commit('app/setLoading', true)
        const params = {
          idFacturae: this.idFacturae,
          idInvoice: this.idInvoice,
          idRelatedDocument: row.idRelatedDocument,
        }
        let response
        if (row.idRelatedDocument === 0) {
          response = await descargarDocFactura(params)
        } else {
          if (!docRel) {
            response = await descargarAdjunto(params)
          } else {
            response = await descargarDocRel(params)
          }
        }
        const blob = new Blob([response.data], { type: response.data.type, encoding: 'UTF-8' })
        const link = document.createElement('a')
        link.href = window.URL.createObjectURL(blob)
        // const headerVal = response.headers['content-disposition']
        let filename = row.Nombre
        filename = decodeURI(filename)
        link.download = filename
        link.click()
      } catch (error) {
        console.error(error)
        if (error.response?.data) {
          const errorText = await error.response.data.text()
          this.doFeedback(errorText)
        } else {
          this.doFeedback()
        }
      } finally {
        this.$store.commit('app/setLoading', false)
      }
    },
    printAdjunto: async function (row, docRel = false) {
      try {
        this.$store.commit('app/setLoading', true)
        const params = {
          idFacturae: this.idFacturae,
          idInvoice: this.idInvoice,
          idRelatedDocument: row.idRelatedDocument,
        }
        let response
        if (row.idRelatedDocument === 0) {
          if (this.form.FacturaeFile.Extension.toLocaleLowerCase() === 'xml') {
            this.prettyPrintXML(params)
            return
          } else {
            response = await descargarDocFactura(params)
          }
        } else {
          if (!docRel) {
            response = await descargarAdjunto(params)
          } else {
            response = await descargarDocRel(params)
          }
        }
        const blob = new Blob([response.data], { type: response.data.type, encoding: 'UTF-8' })

        var iframe = document.getElementById('printeriframe')
        if (iframe) iframe.remove()
        iframe = document.createElement('iframe')
        iframe.setAttribute('id', 'printeriframe')
        iframe.style.display = 'none'
        document.body.appendChild(iframe)

        iframe.onload = function () {
          iframe.focus()
          iframe.contentWindow.print()
          // iframe.remove()
        }
        iframe.src = window.URL.createObjectURL(blob)
      } catch (error) {
        console.error(error)
        if (error.response?.data) {
          const errorText = await error.response.data.text()
          this.doFeedback(errorText)
        } else {
          this.doFeedback()
        }
      } finally {
        this.$store.commit('app/setLoading', false)
      }
    },
    prettyPrintXML: async function (params) {
      var response = await getXHTMLFactura(params)
      if (!response.blnError) {
        var iframe = document.getElementById('printeriframe')
        if (iframe) iframe.remove()
        iframe = document.createElement('iframe')
        iframe.setAttribute('id', 'printeriframe')
        iframe.style.display = 'none'
        document.body.appendChild(iframe)
        var iframeContent = iframe.contentWindow || (iframe.contentDocument.document || iframe.contentDocument)

        iframeContent.document.open()
        iframeContent.document.write(response.Respuesta)
        iframeContent.document.close()
        var a = [...iframeContent.document.querySelectorAll('a[id $= Link]')]
        a.filter(x => x.innerText === 'Mostrar más datos').forEach(x => iframeContent.mostrarCapa(x.id.substring(0, x.id.length - 'Link'.length)))
        iframeContent.print()
        iframe.remove()
      } else {
        this.doFeedback(`${response.msgError} [${response.codError}]`)
      }
    },
    printXMLView: function () {
      var iframe = document.getElementById('container-xhtml-iframe')
      var iframeContent = iframe.contentWindow || (iframe.contentDocument.document || iframe.contentDocument)
      iframeContent.print()
    },
    downloadXMLView: function () {
      this.doFeedback(new Error(i18n.t('feedback.error.feature_not_implemented')))
      // var iframe = document.getElementById('container-xhtml-iframe')
      // var iframeContent = iframe.contentWindow || (iframe.contentDocument.document || iframe.contentDocument)
      // var link = document.createElement('a')
      // link.href = `data:text/html;charset=UTF-8,${encodeURIComponent(iframeContent.document.documentElement.outerHTML)}`
      // var filename = this.form.FacturaeFile.Nombre.split('.')
      // link.download = `${[filename.slice(0, filename.length - 1)].join('.')}.html`
      // link.click()
    },
    showPDFHandler: async function (idRelatedDocument, withoutEvent = false, docRel = false) {
      try {
        this.$store.commit('app/setLoading', true)

        const params = {
          idFacturae: this.idFacturae,
          idInvoice: this.idInvoice,
          idRelatedDocument: idRelatedDocument,
          automatico: withoutEvent
        }

        let adjunto
        if (idRelatedDocument === 0) {
          adjunto = await descargarDocFactura(params)
        } else if (!docRel) {
          adjunto = await descargarAdjunto(params)
        } else {
          adjunto = await descargarDocRel(params)
        }
        const blob = new Blob([adjunto.data], {
          type: 'application/pdf'
        })
        const url = URL.createObjectURL(blob)
        this.url = url
        // window.open(url)
      } catch (error) {
        this.doFeedback(i18n.t('feedback.error.download_file_error'))
      } finally {
        this.$store.commit('app/setLoading', false)
      }
    },
    truncate: function (str, n, useWordBoundary) {
      if (str.length <= n) { return str }
      const subString = str.substr(0, n - 1) // the original check
      return (useWordBoundary
        ? subString.substr(0, subString.lastIndexOf(' '))
        : subString) + '...'
    },
    openUrlHacienda: function () {
      window.open(this.form.urlHacienda, '_blank')
    },
    openUrlVerifactu: function () {
      window.open(this.form.urlVerifactu, '_blank')
    }
  },
}
</script>

<style scoped>
.full-screen-pdf {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 99999;
}

.box {
  background-color: #444;
  color: #fff;
  border-radius: 5px;
  border: 1px solid black;
  padding: 5px 20px;
}

.grid {
  display: grid;
  grid-gap: 10px;
}

.wrapper {
  grid-template-columns: 1fr 1fr;
  background-color: seagreen;
  padding: 10px;
  width: 50%;
  margin: 20px auto;
}

.grid.left {
  grid-column: 1 / span 1;
  grid-auto-rows: min-content;
}

.grid.right {
  grid-column: span 1 / -1;
  grid-auto-rows: min-content;
}

.tip {
  grid-column: 1 / -1;
}

.pic>img {
  max-width: 100%;
  max-height: 100%;
}
</style>

<style lang="scss" >
.hideHeader {
  display: none
}

.showHeader {
  display: block
}

.hideHScroll {
  overflow-x: hidden;
}
.iframe-xhtml {
  height: 96.2%; 
  min-height: 800px
}
</style>
